import { Project } from "@app/projects";
import { fromNullable } from "@app/shared";
import { QESCheckbox, QESTextInput } from "@app/shared/qes-standards";
import { ResourceTagModel } from "@app/tags/import/types";
import TagResource from "@app/tags/TagResource";
import { ManageResourceTagDisplayModel } from "@app/tags/types";
import { RoleRestricted, Roles } from "@app/user";
import { Component, Fragment } from "react";

interface DetailsProps {
  disabled: boolean;
  onDescChange: (desc: string) => void;
  onIsPrivateChange: (isPrivate: boolean) => void;
  onNameChange: (char: string) => void;
  onTaggingChange: (tags: ResourceTagModel[]) => void;
  project: Project;
  projectDescriptionOk: boolean;
  projectNameOk: boolean;
  projectNameValue: string;
  resourceTags: ManageResourceTagDisplayModel[];
}

export class Details extends Component<DetailsProps> {
  constructor(props: DetailsProps) {
    super(props);
  }

  public render() {
    return (
      <Fragment>
        <div className="tab-contents col-12">
          <div className={`form-group row ${fromNullable(this.props.projectNameOk, "", "has-error", "has-error")}, col-12`}>
            <div className="col-6 offset-2">
              <QESTextInput
                label="Name"
                value={this.props.projectNameValue}
                onBlur={(e) => this.props.onNameChange(e.target.value.trim())}
                onChange={(e) => this.props.onNameChange(e.target.value)}
                disabled={this.props.disabled}
                testId="edit-details__edit-project-name-text-box"
                required={true}
                isValid={this.props.projectNameOk}
                descriptiveText={!this.props.projectNameOk && "The project must have a name, and it cannot match any other project names."}
                maxLength={255}
              />
            </div>
          </div>

          <div className={`form-group row ${fromNullable(this.props.projectDescriptionOk, "", "has-error", "has-error")}, col-12`}>
            <div className="col-6 offset-2">
              <QESTextInput
                label="Description"
                placeholder="Project Description"
                value={this.props.project?.resource?.description}
                onChange={(e) => this.props.onDescChange(e.target.value)}
                disabled={this.props.disabled}
                testId="edit-details__edit-project-description-text-box"
                required={true}
                isValid={this.props.projectDescriptionOk}
                descriptiveText={!this.props.projectDescriptionOk && "Description must not be empty."}
                maxLength={255}
              />
            </div>
          </div>

          <RoleRestricted allowedRoles={[Roles.CLIENT_ADMIN]}>
            <div className="form-group row col-12">
              <TagResource
                resourceTags={this.props.resourceTags}
                tags={this.props.project.tags && this.props.project.tags.length > 0 ? this.props.project.tags : [{ tagGroupName: "", tagName: "" } as ResourceTagModel]}
                disabled={this.props.disabled}
                handleTaggingChange={this.props.onTaggingChange}
              />
            </div>
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.RESOURCE_ADMIN]}>            
            <div className="form-group row, col-12">
              <div className="col-6 offset-2">
                <QESCheckbox
                  label="This is a Private Project (can be administered only by you)"
                  checked={this.props.project?.resource?.isPrivate}
                  onChange={(e) => this.props.onIsPrivateChange(e.target.checked)}
                  disabled={this.props.disabled}
                  testId="edit-details__edit-project-is-private-checkbox"
                />
              </div>
            </div>
          </RoleRestricted>
        </div>
      </Fragment>
    );
  }
}
